import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.habilidad.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.habilidad.fields.nombre'),
  },
  {
    name: 'incluirEstadisticas',
    label: i18n('entities.habilidad.fields.incluirEstadisticas'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.habilidad.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.habilidad.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
